import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    applicationCompleted: {
      subtitle: 'Send it back to us so that we can verify your information.',
      title: 'Your application is complete!',
    },
    errorSubtitle:
      'Please go back on the steps highlighted in red to finalize your application.',
    originalErrorMessage: 'Your original message:',
    submitApplication: {
      resend: 'Resubmit my application',
      send: 'Submit my application',
    },
    subtitle: 'Provided information will be automatically saved.',
    title: 'Complete your application',
  },

  fr: {
    applicationCompleted: {
      subtitle:
        'Renvoyez-le nous pour que nous puissions procéder à la vérification de vos informations.',
      title: 'Votre dossier est complet !',
    },
    errorSubtitle:
      'Veuillez revenir sur les étapes indiquées en rouge afin de finaliser votre dossier.',
    originalErrorMessage: 'Votre message initial :',
    submitApplication: {
      resend: 'Renvoyer mon dossier',
      send: 'Envoyer mon dossier',
    },
    subtitle: 'Les informations renseignées sont automatiquement enregistrées.',
    title: 'Compléter votre dossier',
  },
} as const);
